import UrlHelper from 'foundation/url-helper';
import ObjectHelper from 'foundation/object-helper';
import { CONTROL_TYPE_CHECKLIST, CONTROL_TYPE_SELECT } from './constants';

export function getDefaultFilters(filters) {
    return filters.reduce((defaultFilters, filterConfig) => {
        switch (filterConfig.type) {
            case CONTROL_TYPE_CHECKLIST: {
                defaultFilters[filterConfig.name] = filterConfig.defaultValue;
                break;
            }
            case CONTROL_TYPE_SELECT: {
                const defaultItem = filterConfig.options.find((f) => f.isDefault);
                if (defaultItem) {
                    defaultFilters[filterConfig.name] = defaultItem.value;
                } else {
                    console.error(`filter ${filterConfig.name} doesn't have a default value. the filter will be ignored`);
                }
                break;
            }
            default:
                throw new Error('unknown filter type');
        }

        return defaultFilters;
    }, {});
}

export function getPathWithQueryString(location, exceptParams = []) {
    const baseUrl = location.pathname;
    const searchObject = UrlHelper.getSearchFromLocation(location);
    const paramsKeys = Object.keys(searchObject).filter((key) => exceptParams.indexOf(key) === -1);
    const paramsObject = paramsKeys.reduce((result, key) => {
        result[key] = searchObject[key];
        return result;
    }, {});
    return UrlHelper.getUrlByParams(baseUrl, paramsObject);
}


export function isFilterValuesEqual(parameter1, parameter2) {
    if ((ObjectHelper.isObject(parameter1) && ObjectHelper.isObject(parameter2)) || (Array.isArray(parameter1) && Array.isArray(parameter2))) {
        return ObjectHelper.isEqual(parameter1, parameter2);
    }

    return parameter1 === parameter2;
}


export function isFiltersDirty(filters, filtersConfigs) {
    return filtersConfigs.some((filterConfig) => {
        const name = filterConfig.name;
        return (name in filters) && !isFilterValuesEqual(filters[filterConfig.name], filterConfig.defaultValue);
    });
}
